// services/notification.service.ts
import api from './api';

export type NotificationType = 'lead' | 'vehicle' | 'system' | 'message';
export type NotificationPriority = 'low' | 'normal' | 'high';

export type AppNotification = {
  id: string;
  type: NotificationType;
  title: string;
  body: string | null;
  link: string | null;
  priority: NotificationPriority;
  isRead: boolean;
  readAt: string | null;
  metadata: Record<string, any> | null;
  createdAt: string;
};

export type NotificationListResponse = {
  items: AppNotification[];
  pagination: { page: number; limit: number; total: number; pages: number };
  unreadCount: number;
};

export const getNotifications = async (params?: {
  page?: number;
  limit?: number;
  filter?: 'all' | 'unread';
  type?: NotificationType | 'all';
}): Promise<NotificationListResponse> => {
  const { data } = await api.get<{ success: boolean; data: NotificationListResponse }>(
    '/notifications',
    { params }
  );
  return data.data;
};

export const getUnreadCount = async (): Promise<number> => {
  const { data } = await api.get<{ success: boolean; data: { count: number } }>(
    '/notifications/unread-count'
  );
  return data.data.count;
};

export const markNotificationRead = async (id: string): Promise<void> => {
  await api.patch(`/notifications/${id}/read`);
};

export const markAllNotificationsRead = async (): Promise<number> => {
  const { data } = await api.patch<{ success: boolean; data: { updated: number } }>(
    '/notifications/read-all'
  );
  return data.data.updated;
};

export const deleteNotification = async (id: string): Promise<void> => {
  await api.delete(`/notifications/${id}`);
};